export enum TimeModeType {
    week = 'week',
    month = 'month',
    period = 'period',
    year = 'year',
    date = 'date',
    custom = 'custom',
}
